import React from "react";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import { makeStyles, Grid } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2, 2, 2, 2),
  },
}));
const Splash: React.FC = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <Grid container justify="flex-start">
        <Grid item xs={12} md={6}>
          <Paper className={classes.root}>
            <Typography variant="body1">
              <p>
                Welcome to the Vital Teams survey. Our specialty is team
                performance. Whether you are setting up a new team or need to
                improve the performance of your existing team, we have the tools
                and expertise to help you get team fit.
              </p>
              <p>
                If you would like to know more, please contact us at{" "}
                <a href="mailto:info@vitalteams.com">info@vitalteams.com</a>
              </p>
              <p>
                If you are looking for your unique survey link, please contact
                us at{" "}
                <a href="mailto:support@vitalteams.com">
                  support@vitalteams.com
                </a>
              </p>
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default Splash;
